import Cookies from 'js-cookie'
import { logger } from 'APP/Lib/Datadog'

export const setSecureStorageEntry = (key: string, value: string): Promise<void> => {
  try {
    Cookies.set(key, JSON.stringify(value || null), { secure: true, sameSite: 'Strict' })
  } catch (e) {
    logger.error('Failed to set secure storage entry:', {}, e)
  }
  return Promise.resolve()
}

export const getSecureStorageEntry = (key: string): Promise<string | null> => {
  try {
    const entry = Cookies.get(key)
    return Promise.resolve(entry ? JSON.parse(entry) : null)
  } catch (e) {
    logger.error('Failed to get secure storage entry:', {}, e)
    return Promise.resolve(null)
  }
}

export const removeSecureStorageEntry = (key: string): Promise<void> => {
  try {
    Cookies.remove(key)
  } catch (e) {
    logger.error('Failed to remove secure storage entry:', {}, e)
  }
  return Promise.resolve()
}
